'use client';

import { gridShuffleFrame } from './shared-ui-grid-shuffle-loading.helpers';
import LogoLoading from './shared-ui-logo-loading';
import type { LogoLoadingProps } from './shared-ui-logo-loading.types';

const GridShuffleLoading = (props: LogoLoadingProps) => (
  <LogoLoading
    {...props}
    frame={gridShuffleFrame}
    dataTest='grid-shuffle-loading'
  />
);

export default GridShuffleLoading;
